export function formatCanadianTaxId(value) {
  const strippedValue = value.replace(/[^\dA-Za-z]/g, '');
  const formatted = [...strippedValue];
  if (formatted.length === 8 || formatted.length === 11) {
    // Format PST
    if (formatted.length !== 8) {
      formatted.splice(-8, 0, ' ');
    }
    formatted.splice(-4, 0, ' ');
  } else if (formatted.length > 10) {
    // Format QST/HST/GST
    formatted.splice(-6, 0, ' ');
    formatted.splice(-4, 0, ' ');
  }
  return formatted.join('');
}
export function formatCanadianPstRstQstId(value) {
  return value.replace(/[^\d\sA-Za-z-]/g, '');
}